import { getFirestore, collection, doc, getDoc, getDocs } from "firebase/firestore";

export async function getSubscriptionDetails(uid) {
  const db = getFirestore();

  // 1. Read user doc for subscription source info
  const userDoc = await getDoc(doc(db, "users", uid));
  const userData = userDoc.exists() ? userDoc.data() : {};

  // 2. Read subscriptions subcollection (Stripe Extension writes here)
  const subsSnap = await getDocs(collection(db, "users", uid, "subscriptions"));
  const subscriptions = [];

  for (const subDoc of subsSnap.docs) {
    const sub = subDoc.data();

    let productData = null;
    let priceData = null;

    // Resolve product reference
    if (sub.product) {
      try {
        const productSnap = await getDoc(sub.product);
        if (productSnap.exists()) productData = productSnap.data();
      } catch (e) {
        console.warn("Failed to resolve product ref:", e);
      }
    }

    // Resolve price reference
    if (sub.price) {
      try {
        const priceSnap = await getDoc(sub.price);
        if (priceSnap.exists()) priceData = priceSnap.data();
      } catch (e) {
        console.warn("Failed to resolve price ref:", e);
      }
    }

    subscriptions.push({
      id: subDoc.id,
      status: sub.status,
      role: sub.role,
      currentPeriodEnd: sub.current_period_end?.toDate?.() || null,
      currentPeriodStart: sub.current_period_start?.toDate?.() || null,
      trialStart: sub.trial_start?.toDate?.() || null,
      trialEnd: sub.trial_end?.toDate?.() || null,
      cancelAtPeriodEnd: sub.cancel_at_period_end || false,
      product: productData,
      price: priceData,
    });
  }

  // Find the most relevant subscription (active/trialing first)
  const activeSub = subscriptions.find(
    (s) => s.status === "active" || s.status === "trialing"
  );
  const cancelingSub = subscriptions.find(
    (s) => s.cancelAtPeriodEnd && (s.status === "active" || s.status === "trialing")
  );
  const currentSub = cancelingSub || activeSub || subscriptions[0] || null;

  return {
    subscriptionSource: userData.subscriptionSource || null,
    revenuecatProductId: userData.revenuecatProductId || null,
    stripeRole: userData.stripeRole || null,
    subscription: currentSub,
    allSubscriptions: subscriptions,
  };
}
